"use strict";

const IncidentInvestigationController = function () {
  const htmlPath = "modals/incidentInvestigation";
  const formKey = "incident-investigation";

  let $modal;
  let tabs;
  let data;

  var loadIncidentInvestigation = async function ({
    maybeId,
    incidentId,
    readOnly,
    investigationType,
  } = {}) {
    if (maybeId !== undefined) {
      data = await ApiCalls.getIncidentInvestigation(maybeId);
      data.incidentInfo = await ApiCalls.getIncident(data.incidentId);
    } else {
      data = await ApiCalls.getIncident(incidentId);
      data = IncidentInvestigationConstants.getNewIncidentInvestigationDefaults(data);
      if (investigationType) {
        data.investigationType = investigationType;
      }
    }
    showIncidentInvestigationModal(data, readOnly);
  };

  var showIncidentInvestigationModal = function (data, readOnly) {
    const GeneralInfo = require("./incidentInvestigationGeneralInfo");
    const InspectClean = require("./incidentInvestigationInspectClean");
    const Flow = require("./incidentInvestigationFlow");
    const ResponsibleParty = require("./incidentInvestigationResponsibleParty");
    const Submission = require("./incidentInvestigationSubmission");
    tabs = [GeneralInfo, InspectClean, Flow, ResponsibleParty, Submission];
    const renderData = mapTabProps(tabs, data);

    $modal = TabbedModal.showTabbedModal(formKey, renderData, tabs, htmlPath, {
      readOnly,
      saveButtonText: "Save",
      extraButtons: [],
    });
    Form.initializeAndLoadListeners($modal, formKey);

    FormSettings.customizeForm($modal, formKey);

    const existingFiles = data.files ?? [];
    Form.initializeDropzone(formKey, $modal, {
      existingFiles: existingFiles,
      downloadCallback: ApiCalls.downloadIncidentInvestigationFile,
    });

    loadListeners();

    checkFlowTab(data);
    checkInspectCleanTab(data);
    togglePrecipitationSection(data.investigationType);
    toggleSiteRepSection(data.investigationType);
    toggleEnforcementsSection(data.incidentInfo.responsiblePartyIdentified);
    setInspectionHeaderText(data);
    setAdditionalModalHandlers();
  };

  var loadListeners = function () {
    unloadListeners();

    $modal.on(
      "2N:FormInput",
      "[name='incident-type'], [name='responsible-party-identified']",
      rerenderSummary,
    );
    $modal.on(
      "2N:FormInput",
      "[name='responsible-party-identified']",
      onResponsiblePartyIdentifiedChange,
    );

    $modal.on("2N:FormInput", "[name='investigation-type']", onInvestigationTypeChange);
  };

  var unloadListeners = function () {
    $modal.off(
      "2N:FormInput",
      "[name='incident-type'], [name='responsible-party-identified']",
      rerenderSummary,
    );
    $modal.off(
      "2N:FormInput",
      "[name='responsible-party-identified']",
      onResponsiblePartyIdentifiedChange,
    );
    $modal.off("2N:FormInput", "[name='investigation-type']", onInvestigationTypeChange);
  };

  var mapTabProps = function (tabs, data) {
    const tabProps = tabs.reduce((props, tab) => {
      return $.extend(true, props, tab.getProps(data));
    }, {});
    return {
      ...data,
      ...tabProps,
    };
  };

  var getHeaderHtml = function (data) {
    if (data.incidentInfo.requestingType) {
      data.incidentInfo.displayRequestingType =
        IncidentInventoryConstants.getRequestingTypeOptions().getObjectWith(
          "value",
          data.incidentInfo.requestingType,
        )?.name;
    }
    return nunjucks.render("modals/incidentInvestigation/incidentInvestigationHeader.njk", data);
  };

  var setInspectionHeaderText = function (data) {
    TabbedModal.setHeaderText(getHeaderHtml(data));
  };

  var checkFlowTab = function (data) {
    $("#assessment-modal #measurements").show();
    if (
      data.incidentType === "illicit-flow" &&
      data.flowCharacteristicsCollected === true &&
      data.investigationType !== "follow-up-informal"
    ) {
      toggleFlowTab(true);
    } else {
      toggleFlowTab(false);
    }
  };

  var checkInspectCleanTab = function (data) {
    const show = data.investigationType !== "follow-up-informal";
    toggleInspectCleanTab(show);
  };

  var setAdditionalModalHandlers = function () {
    TabbedModal.setCancelHandler(() => {});
    TabbedModal.setSaveHandler(saveButtonClick, false);
    TabbedModal.setFormHasUpdatesHandler(formHasUpdates);
  };

  var saveButtonClick = async function () {
    const fields =
      IncidentInvestigationValidator.getMissingRequiredFields(getInspectionRenderData());
    showSaveAndWarnModal(fields);
    highlightInvalidFields(fields);

    return false;
  };

  var showSaveAndWarnModal = function (fields) {
    const uniqueMessages = [...new Set(fields.map((field) => field.message))];

    const incompleteFields = {
      entityName: data.incidentInfo?.incidentName,
      entityKind: "investigation",
      incompleteFieldNames: uniqueMessages,
    };
    const buttonCallbacks = {
      cancelCallback: null,
      saveCallback: saveAndCloseModal,
      submitCallback: function () {
        setFormData(["locked"], true);
        saveAndCloseModal();
      },
    };

    SaveIncompleteModal.showWarnSaveSubmitModal(incompleteFields, buttonCallbacks);
  };

  var highlightInvalidFields = function (fields) {
    const fieldNames = fields.map((field) => field.fieldName);
    CommonModalFunctions.highlightFormFields($modal, fieldNames);
  };

  var saveAndCloseModal = async function () {
    try {
      await Form.getReadyToSavePromise(formKey);
      const editExisting = data.id !== undefined;
      const dataToUpload = _getUpdateData(editExisting);

      if (editExisting) {
        const formData = Form.toFormData({
          id: data.id,
          updates: dataToUpload,
        });
        await ApiCalls.updateIncidentInvestigation(formData);
      } else {
        const formData = Form.toFormData({
          updates: dataToUpload,
        });
        await ApiCalls.createIncidentInvestigation(formData);
      }

      TabbedModal.hide();
      IncidentsGeoServerLayer.invalidateLayerData();
    } catch (e) {
      return UploadValidator.reportError(e);
    }
  };

  var _getUpdateData = function (editExisting = false) {
    let dataToUpload = $.extend(true, {}, Form.getDataFromForm(formKey, false));

    processInspectionFormData(dataToUpload);

    if (editExisting) {
      dataToUpload = mergeIncidentIdIntoUpdates(dataToUpload);
    } else {
      dataToUpload = mergeDefaultsIntoUpdates(dataToUpload);
    }
    delete dataToUpload["incidentInfo"];

    return dataToUpload;
  };

  var mergeIncidentIdIntoUpdates = function (updates) {
    if (updates.incidentInfo) {
      updates.incidentInfo.id = data.incidentInfo.id;
    }
    return updates;
  };

  var processInspectionFormData = function (dataToUpload) {
    dataToUpload.maintenanceType = "routine";

    processInspectionAttribute(dataToUpload, "measurements");
    processInspectionAttribute(dataToUpload, "samples");
  };

  var processInspectionAttribute = function (object, path) {
    if (object !== undefined && object[path] !== undefined) {
      const existingValues = getExistingInspectionData()[path];
      cleanInspectionIds(existingValues, object[path]);
      object[path] = Object.values(object[path]);
    }
  };

  var cleanInspectionIds = function (existingData, inspectionData) {
    const existingIds = existingData
      ? existingData.map((data) => {
          return data.id;
        })
      : [];
    Misc.removeAttributeValues(existingIds, inspectionData, "id");
  };

  var mergeDefaultsIntoUpdates = function (dataToUpload) {
    return $.extend(true, {}, data, dataToUpload);
  };

  var formHasUpdates = function () {
    return !Form.isFormEmpty(formKey);
  };

  var getInspectionRenderData = function () {
    return $.extend(true, {}, data, Form.getDataFromForm(formKey, false));
  };

  var getExistingInspectionData = function () {
    return $.extend(true, {}, data);
  };

  var getFormData = function (path) {
    return Form.getFormDataAtPath(formKey, path);
  };

  var setFormData = function (path, data) {
    return Form.manuallySetFormDataField(formKey, path, data);
  };

  var unsetFormData = function (path) {
    return Form.manuallyUnsetField(formKey, path);
  };

  var toggleFlowTab = function (visibility = false) {
    TabbedModal.toggleTab("flow", visibility);
  };

  var toggleInspectCleanTab = function (visibility = false) {
    TabbedModal.toggleTab("inspectClean", visibility);
  };

  var rerenderSummary = function () {
    IncidentInvestigationSubmission.renderSummary(_getUpdateData());
  };

  var onInvestigationTypeChange = function () {
    const investigationType = this.value;

    checkFlowTab(getInspectionRenderData());
    checkInspectCleanTab(getInspectionRenderData());
    togglePrecipitationSection(investigationType);
    toggleSiteRepSection(investigationType);
  };

  var togglePrecipitationSection = function (investigationType) {
    const show = investigationType !== "follow-up-informal";
    $modal.find(`.precipitation-section`).toggle(show);
  };

  var onResponsiblePartyIdentifiedChange = function (e, identified) {
    toggleEnforcementsSection(identified);
  };

  var toggleEnforcementsSection = function (identified) {
    $modal.find(`.enforcements-section`).toggle(identified === true || identified === "true");
  };

  var toggleSiteRepSection = function (investigationType) {
    const show = investigationType !== "follow-up-informal";
    $modal.find(`.hide-follow-up-informal`).toggle(show);
  };

  return {
    loadIncidentInvestigation,
    showIncidentInvestigationModal,
    toggleFlowTab,
    checkFlowTab,
    getInspectionRenderData,
    getExistingInspectionData,
    getFormData,
    setFormData,
    unsetFormData,
    saveAndCloseModal,
    _getUpdateData,
  };
};

module.exports = IncidentInvestigationController();

const ApiCalls = require("../../apiCalls");
const UploadValidator = require("../../general/uploadValidator");
const Form = require("../../general/form");
const FormSettings = require("../../settings/formSettings");
const Misc = require("../../misc");
const IncidentsGeoServerLayer = require("../incidents/incidentsGeoServerLayer");
const IncidentInventoryConstants = require("../incidents/incidentInventoryConstants");
const IncidentInvestigationConstants = require("./incidentInvestigationConstants");
const IncidentInvestigationValidator = require("./incidentInvestigationValidator");
const TabbedModal = require("../../general/tabbedModal");
const IncidentInvestigationSubmission = require("./incidentInvestigationSubmission");
const SaveIncompleteModal = require("../../modals/saveIncompleteModal");
const CommonModalFunctions = require("../../modals/commonModalFunctions");
